/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConversionsBySnapshotSourceFromJSON, ConversionsBySnapshotSourceToJSON } from './ConversionsBySnapshotSource';
/**
 * Check if a given object implements the ConversionsStats interface.
 */
export function instanceOfConversionsStats(value) {
    if (!('bySnapshotSource' in value) || value['bySnapshotSource'] === undefined)
        return false;
    if (!('withSnapshotCount' in value) || value['withSnapshotCount'] === undefined)
        return false;
    if (!('withSnapshotValueSum' in value) || value['withSnapshotValueSum'] === undefined)
        return false;
    if (!('withoutSnapshotCount' in value) || value['withoutSnapshotCount'] === undefined)
        return false;
    return true;
}
export function ConversionsStatsFromJSON(json) {
    return ConversionsStatsFromJSONTyped(json, false);
}
export function ConversionsStatsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bySnapshotSource': (json['by_snapshot_source'].map(ConversionsBySnapshotSourceFromJSON)),
        'withSnapshotCount': json['with_snapshot_count'],
        'withSnapshotValueSum': json['with_snapshot_value_sum'],
        'withoutSnapshotCount': json['without_snapshot_count'],
    };
}
export function ConversionsStatsToJSON(json) {
    return ConversionsStatsToJSONTyped(json, false);
}
export function ConversionsStatsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'by_snapshot_source': (value['bySnapshotSource'].map(ConversionsBySnapshotSourceToJSON)),
        'with_snapshot_count': value['withSnapshotCount'],
        'with_snapshot_value_sum': value['withSnapshotValueSum'],
        'without_snapshot_count': value['withoutSnapshotCount'],
    };
}
